import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleMenuComponentModule } from '@accredible-frontend-v2/new-components/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccredibleButtonFilterComponent } from './button-filter.component';

@NgModule({
  imports: [CommonModule, AccredibleButtonComponentModule, AccredibleMenuComponentModule],
  exports: [AccredibleButtonFilterComponent],
  declarations: [AccredibleButtonFilterComponent],
})
export class AccredibleButtonFilterComponentModule {}
